module.exports = __webpack_public_path__ + "static/img/reward3.7866dbd9.png";